// import external dependencies
// import './scrollreveal/scrollreveal.min.js';
import 'jquery';
import 'jquery-parallax.js';
// import 'aos/dist/aos.js';
// import '../../../node_modules/jquery-parallax.js/jquery.min.js';

// Import everything from autoload
import "./autoload/_bootstrap.js"
import "./cycle2/jquery.cycle2.min.js"
import "./cycle2/jquery.cycle2.swipe.min.js"
import "./cycle2/jquery.cycle2.carousel.min.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js